import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'app/services/auth.service';
import { ReminderSettingService } from 'app/services/models/reminder-setting.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-reminder-setting-dialog',
  templateUrl: './reminder-setting-dialog.component.html',
  styleUrls: ['./reminder-setting-dialog.component.scss']
})
export class ReminderSettingDialogComponent implements OnInit {
  @Input() data;
  form: FormGroup;

  constructor(
    private activeModal: NgbActiveModal,
    private reminderSettingService: ReminderSettingService,
    private fb: FormBuilder,
    private toatrService: ToastrService,
    public authService: AuthService) { }

  async ngOnInit() {
    this.form = this.fb.group({
      settings: this.fb.array([])
    });
    if (this.data)
      await this.getByIdReminderSettings(this.data);
  }

  get settings(): FormArray {
    return this.form.get('settings') as FormArray;
  }

  private settingRow(item?: any): FormGroup {
    return this.fb.group({
      id: [item?.id || null],                // update için id
      reminderId: [this.data],               // create için reminderId
      daysBefore: [item?.daysBefore || 0, Validators.required],
      timesPerDay: [item?.timesPerDay || 0, Validators.required]
    });
  }

  async getByIdReminderSettings(id: number) {
    if(this.authService.isEndpointStatus('GET.Reading.GetByIdReminderSetting')){
      const result = await this.reminderSettingService.getAllReminderByIdSettings(id);
      // result örneğin [{id:1,daysBefore:2,timesPerDay:1}, ...]
      console.log(result);
      result.forEach((r: any) => this.settings.push(this.settingRow(r)));
      if (this.settings.length === 0) {
        // hiç kayıt yoksa bir boş satır aç
        this.addRow();
      }
    }
  }

  addRow() {
    this.settings.push(this.settingRow());
  }

  async removeCallBack() {
    this.settings.clear();

    await this.getByIdReminderSettings(this.data);

  }

  async save() {
    if (this.form.invalid) return;

    const updates: any[] = [];
    const creates: any[] = [];

    this.settings.controls.forEach(ctrl => {
      const val = ctrl.value;
      if (val.id) {
        // güncelleme listesi
        updates.push({
          id: val.id,
          daysBefore: val.daysBefore,
          timesPerDay: val.timesPerDay
        });
      } else {
        // yeni kayıt listesi
        creates.push({
          reminderId: this.data,
          daysBefore: val.daysBefore,
          timesPerDay: val.timesPerDay
        });
      }
    });

    try {
      // önce güncelle
      for (const u of updates) {
        await this.reminderSettingService.updateReminderSetting(u);
      }

      // sonra yeni kayıtlar varsa create
      if (creates.length > 0) {
        await this.reminderSettingService.createReminderSetting(creates);
      }

      this.toatrService.success('Ayarlar başarıyla kaydedildi');
      this.activeModal.close(true);
    } catch (err) {
      console.error(err);
      this.toatrService.error('Kayıt sırasında hata oluştu');
    }
  }

  onClose(result: boolean) {
    this.activeModal.close(result);
  }

}
